module.exports = __webpack_public_path__ + "static/media/all-slowmotion.e0e75e5b.mp3";